import api from './api';

const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const normalizeVendorSummary = (payload = {}) => {
  const source = {
    ...payload,
    ...(payload.data || {}),
    ...(payload.summary || {}),
    ...(payload.stats || {}),
  };

  return {
    totalSales: toNumber(source.total_sales ?? source.totalSales ?? source.total_amount ?? source.revenue ?? source.sales),
    netAmount: toNumber(source.net_amount ?? source.netAmount ?? source.net ?? source.subtotal),
    totalGst: toNumber(source.total_gst ?? source.totalGst ?? source.gst_amount ?? source.gstAmount ?? source.gst),
    totalOrders: toNumber(source.total_orders ?? source.totalOrders ?? source.orders),
    complimentaryBillCount: toNumber(source.complimentary_bill_count ?? source.complimentaryBillCount ?? source.complimentary_count ?? source.complimentaryBills),
    dineInSales: toNumber(source.dine_in_sales ?? source.dineInSales ?? source.dine_in_amount),
    dineInOrders: toNumber(source.dine_in_orders ?? source.dineInOrders),
    pickUpSales: toNumber(source.pick_up_sales ?? source.pickup_sales ?? source.pickUpSales ?? source.pickup_amount),
    pickUpOrders: toNumber(source.pick_up_orders ?? source.pickup_orders ?? source.pickUpOrders),
    deliverySales: toNumber(source.delivery_sales ?? source.deliverySales ?? source.delivery_amount),
    deliveryOrders: toNumber(source.delivery_orders ?? source.deliveryOrders),
  };
};

export const normalizeVendorSalesPerformance = (payload = {}) => {
  const source = {
    ...payload,
    ...(payload.data || {}),
    ...(payload.performance || {}),
    ...(payload.sales_performance || {}),
  };

  return {
    totalSales: toNumber(source.total_sales ?? source.totalSales ?? source.total_amount ?? source.revenue),
    totalOrders: toNumber(source.total_orders ?? source.totalOrders ?? source.orders),
    salesBySlot: (source.sales_by_slot ?? source.salesBySlot ?? source.sales_by_time ?? source.slots ?? []).map((slot) => ({
      timeSlot: slot.time_slot ?? slot.time ?? slot.label ?? slot.slot ?? '',
      dineIn: toNumber(slot.dine_in ?? slot.dineIn ?? slot.dine_in_sales),
      pickUp: toNumber(slot.pick_up ?? slot.pickup ?? slot.pickUp ?? slot.pickup_sales),
      delivery: toNumber(slot.delivery ?? slot.delivery_sales),
    })),
  };
};

const normalizeResponse = (response, normalize) => ({
  ...response,
  data: {
    ...response.data,
    data: normalize(response.data?.data),
  },
});

const buildDashboardParams = (startDate, endDate, branchId, fromTime, toTime) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
  };

  params.branch_id = branchId || 'all';
  if (fromTime) params.from_time = fromTime;
  if (toTime) params.to_time = toTime;

  return params;
};

export const vendorDashboardService = {
  getVendorDashboardSummary: (startDate, endDate, branchId, fromTime, toTime) => (
    api.get('/vendors/dashboard/vendor-summary/', {
      params: buildDashboardParams(startDate, endDate, branchId, fromTime, toTime),
    }).then((response) => normalizeResponse(response, normalizeVendorSummary))
  ),

  getVendorSalesPerformance: (startDate, endDate, branchId, fromTime, toTime) => (
    api.get('/vendors/dashboard/vendor-sales-performance/', {
      params: buildDashboardParams(startDate, endDate, branchId, fromTime, toTime),
    }).then((response) => normalizeResponse(response, normalizeVendorSalesPerformance))
  ),

  getVendorComplimentaryBills: (fromDate, toDate, branchId = 'all') => (
    api.get('/vendors/complimentary-bills/', {
      params: {
        from_date: fromDate,
        to_date: toDate,
        branch_id: branchId || 'all',
      },
    })
  ),
};
